import { Box, TextButton, Typography } from '@wishket/design-system';

import { Icon, IconName } from '@/shared/Components';

interface SummaryTitleProps {
  title: string;
  nickname?: string;
  icon?: IconName;
  onClickSeeAll?: () => void;
}

const SummaryTitle = ({
  title,
  nickname,
  icon,
  onClickSeeAll,
}: SummaryTitleProps) => {
  return (
    <Box className="flex items-center justify-between gap-8">
      <Box className="flex items-center gap-1.5">
        {nickname && (
          <Typography
            variant="subTitle1"
            className="line-clamp-1 text-ellipsis font-medium text-w-gray-900"
          >
            {nickname}의
          </Typography>
        )}
        <Typography
          variant="subTitle1"
          className="shrink-0 font-medium text-w-gray-900"
        >
          {title}
        </Typography>
        {icon && <Icon name={icon} />}
      </Box>
      <Box className="shrink-0 font-medium">
        <TextButton
          text="모두 보기"
          trailingIcon="medium_arrow_right"
          onClick={onClickSeeAll}
        />
      </Box>
    </Box>
  );
};

export default SummaryTitle;
